import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FundinstitutionService } from '../service/fundinstitution.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-fundinstitution-update',
  templateUrl: './fundinstitution-update.component.html',
  styleUrls: ['./fundinstitution-update.component.css']
})
export class FundinstitutionUpdateComponent implements OnInit {

  obj: any = {
    FundInstitutionId: null,
    IncomeTaxAuthorizationNumber: null,
    Name: null,
    Type: null,
    InstitutionName: null,
    IdentityNumber: null,
    BankName: null,
    BankNumber: null,
    BankBranch: null,
    BranchNumber: null,
    AccountNumber: null,
    EmailFinanceSupport: null,
    Notes: null
  }
  cols: any[];
  msgs: any[] = [];
  listBank: any[] = [];
  selectedBankNumber: any = null;

  constructor(private route: ActivatedRoute, private dataService: FundinstitutionService, private router: Router) { }

  ngOnInit() {
    this.dataService.getBank().subscribe((result: any) => {
      this.listBank = result;
      this.listBank.unshift({ label: 'בחירה', value: null });
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת בנקים ');
      });

    let id = this.route.snapshot.paramMap.get('id');
    this.dataService.getFundinstitutionById(parseInt(id)).subscribe((result: any) => {
      this.obj = result;
      this.selectedBankNumber = this.obj.BankNumber;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בעדכון');
      });

    this.cols = [
      { field: 'IncomeTaxAuthorizationNumber', header: 'מספר אישור' },
      { field: 'Name', header: 'שם מוצר' },
      { field: 'Type', header: 'סוג מוצר' },
      { field: 'InstitutionName', header: 'שם הגוף המוסדי' },
      { field: 'IdentityNumber', header: 'ח.פ הגוף המוסדי' },
      { field: 'BankName', header: 'שם בנק' },
      { field: 'BankNumber', header: 'מספר בנק' },
      { field: 'BankBranch', header: 'שם סניף בנק' },
      { field: 'BranchNumber', header: 'מספר סניף בנק' },
      { field: 'AccountNumber', header: 'מספר חשבון' },
      { field: 'EmailFinanceSupport', header: 'כתובת דואל לבירורים בנושאי כספים' },
      { field: 'Notes', header: 'הערה' },
    ];
  }
  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  onSubmit(myForm: NgForm): any {
    if (myForm.valid) {
      if (this.obj.FundInstitutionId == null || this.obj.FundInstitutionId == undefined) {
        this.showMessage('error', '', 'תקלה בעדכון');
        return;
      }
      this.obj.FundInstitutionId = parseInt(this.obj.FundInstitutionId);
      this.obj.IncomeTaxAuthorizationNumber = this.obj.IncomeTaxAuthorizationNumber == null ? "" : parseInt(this.obj.IncomeTaxAuthorizationNumber);
      this.obj.Name = this.obj.Name == null ? "" : this.obj.Name;
      this.obj.Type = this.obj.Type == null ? "" : this.obj.Type;
      this.obj.InstitutionName = this.obj.InstitutionName == null ? "" : this.obj.InstitutionName;
      this.obj.IdentityNumber = this.obj.IdentityNumber == null ? "" : this.obj.IdentityNumber;
      this.obj.BankName = this.obj.BankName == null ? "" : this.obj.BankName;
      this.obj.BankNumber = this.selectedBankNumber;
      this.obj.BankBranch = this.obj.BankBranch == null ? "" : this.obj.BankBranch;
      this.obj.BranchNumber = this.obj.BranchNumber == null ? "" : parseInt(this.obj.BranchNumber);
      this.obj.AccountNumber = this.obj.AccountNumber == null ? "" : parseInt(this.obj.AccountNumber);
      this.obj.EmailFinanceSupport = this.obj.EmailFinanceSupport == null ? "" : this.obj.EmailFinanceSupport;
      this.obj.Notes = this.obj.Notes == null ? "" : this.obj.Notes;
      this.dataService.setFundinstitutionById(this.obj).subscribe((result: any) => {
        if (result = "Success") {
          this.showMessage('success', '', 'העדכון נשמר בהצלחה');
          setTimeout(() => {
            this.router.navigate(['/fundInstitution-list']);
          }, 3000);
        }
        else {
          this.showMessage('error', '', 'תקלה לא צפויה בעדכון');
        }
      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בעדכון');
      });
    }
    else {
      this.showMessage('error', '', 'תקלה בעדכון');
    }
  }
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/fundinstitution-update/fundinstitution-update.component.ts